import React, { ComponentType, ErrorInfo, FC, ReactNode } from 'react';
import Bugsnag from '@bugsnag/js';

import './setUp';

const BugSnagErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);

type FallbackProps = { error: Error; info: ErrorInfo; clearError: () => void };

const ErrorBoundary: FC<{ children: ReactNode; FallbackComponent?: ComponentType<FallbackProps> }> = ({
  children,
  FallbackComponent,
}) =>
  BugSnagErrorBoundary ? (
    <BugSnagErrorBoundary FallbackComponent={FallbackComponent}>{children}</BugSnagErrorBoundary>
  ) : (
    <>{children}</>
  );

export { ErrorBoundary };
